import { NavLink } from 'react-router-dom';
import { Swords, Users, BarChart3, UsersRound, Settings } from 'lucide-react';
import { cn } from '@/lib/utils';

const navItems = [
  { to: '/players', icon: Users, label: 'Players' },
  { to: '/teams', icon: UsersRound, label: 'Teams' },
  { to: '/matches', icon: Swords, label: 'Matches' },
  { to: '/results', icon: BarChart3, label: 'Results' },
  { to: '/settings', icon: Settings, label: 'Settings' },
];

export function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 pb-safe">
      <div className="container flex h-16 items-center justify-around">
        {navItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center justify-center gap-1 px-3 py-2 text-xs transition-colors touch-target',
                isActive
                  ? 'text-primary'
                  : 'text-muted-foreground hover:text-foreground'
              )
            }
          >
            <Icon className="h-5 w-5" />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
